import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const LocationMap = () => {
  const [activeView, setActiveView] = useState("map");

  const locationDetails = {
    address: "Altiplano Leste - Paranoá",
    neighborhood: "Altiplano Leste",
    city: "Brasília",
    state: "DF",
    zipCode: "71680-900",
    coordinates: {
      lat: -15.7801234,
      lng: -47.8901234,
    },
  };

  const nearbyLandmarks = [
    {
      name: "Terminal Rodoviário do Plano Piloto",
      distance: "8km",
      type: "Transporte",
      icon: "Train",
    },
    {
      name: "Shopping Conjunto Nacional",
      distance: "12km",
      type: "Shopping",
      icon: "ShoppingBag",
    },
    {
      name: "Parque da Cidade",
      distance: "15km",
      type: "Lazer",
      icon: "Trees",
    },
    {
      name: "Hospital Regional de Taguatinga",
      distance: "18km",
      type: "Saúde",
      icon: "Heart",
    },
  ];

  const transportOptions = [
    {
      type: "Ônibus",
      lines: ["0.100", "0.101", "0.102"],
      station: "Terminal Altiplano",
      walkTime: "5 min",
      icon: "Bus",
    },
    {
      type: "Carro",
      lines: ["DF-001", "DF-002"],
      station: "Acesso principal",
      walkTime: "1 min",
      icon: "Car",
    },
    {
      type: "Bicicleta",
      lines: ["Ciclovia Paranoá"],
      station: "Acesso direto",
      walkTime: "2 min",
      icon: "Bike",
    },
  ];

  const mapUrl = `https://www.google.com/maps?q=${locationDetails?.coordinates?.lat},${locationDetails?.coordinates?.lng}&z=16&output=embed`;

  return (
    <div className="space-y-8">
      {/* Map Controls */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-4 sm:space-y-0">
        <div>
          <h3 className="text-3xl font-heading font-bold text-foreground mb-2">
            Localização e Acesso
          </h3>
          <p className="text-lg text-muted-foreground">
            Encontre-nos facilmente no Altiplano Leste, Paranoá
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <Button
            variant={activeView === "map" ? "default" : "outline"}
            size="lg"
            onClick={() => setActiveView("map")}
            iconName="Map"
            className="px-6 py-3"
          >
            Mapa
          </Button>
          <Button
            variant={activeView === "transport" ? "default" : "outline"}
            size="lg"
            onClick={() => setActiveView("transport")}
            iconName="Navigation"
            className="px-6 py-3"
          >
            Transporte
          </Button>
        </div>
      </div>
      {/* Map View */}
      {activeView === "map" && (
        <div className="bg-card rounded-xl shadow-warm overflow-hidden border border-border/50">
          <div className="h-96 lg:h-[500px] relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.123456789!2d-47.8901234!3d-15.7801234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a23a3873fee5b%3A0x32b4613b357c717c!2sAltiplano%20Leste%20-%20Parano%C3%A1%2C%20Bras%C3%ADlia%20-%20DF!5e0!3m2!1spt-BR!2sbr!4v1760316412799!5m2!1spt-BR!2sbr"
              width="100%"
              height="1024"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização da Estação Marina da Rocha - Altiplano Leste - Paranoá, Brasília"
            ></iframe>
            <div className="absolute top-6 left-6 bg-background/95 backdrop-blur-sm rounded-xl p-4 shadow-warm border border-border/50">
              <div className="flex items-center space-x-3 mb-3">
                <Icon name="MapPin" size={20} className="text-primary" />
                <span className="font-bold text-foreground text-base">
                  Estação Marina
                </span>
              </div>
              <p className="text-sm text-muted-foreground font-medium">
                {locationDetails?.address}
              </p>
              <p className="text-sm text-muted-foreground">
                {locationDetails?.neighborhood}, {locationDetails?.city}
              </p>
            </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Address Details */}
              <div>
                <h4 className="font-bold text-foreground text-xl mb-6 flex items-center space-x-3">
                  <Icon name="MapPin" size={20} className="text-primary" />
                  <span>Endereço Completo</span>
                </h4>
                <div className="space-y-3 text-base">
                  <p className="text-foreground font-semibold text-lg">
                    {locationDetails?.address}
                  </p>
                  <p className="text-muted-foreground text-lg">
                    {locationDetails?.neighborhood}, {locationDetails?.city} -{" "}
                    {locationDetails?.state}
                  </p>
                  <p className="text-muted-foreground">
                    CEP: {locationDetails?.zipCode}
                  </p>
                </div>
                <div className="mt-6">
                  <Button
                    variant="outline"
                    size="lg"
                    onClick={() =>
                      window.open(
                        `https://maps.google.com?q=${locationDetails?.coordinates?.lat},${locationDetails?.coordinates?.lng}`,
                        "_blank"
                      )
                    }
                    iconName="ExternalLink"
                    className="px-6 py-3"
                  >
                    Abrir no Google Maps
                  </Button>
                </div>
              </div>

              {/* Nearby Landmarks */}
              <div>
                <h4 className="font-bold text-foreground text-xl mb-6 flex items-center space-x-3">
                  <Icon name="Compass" size={20} className="text-secondary" />
                  <span>Pontos de Referência</span>
                </h4>
                <div className="space-y-4">
                  {nearbyLandmarks?.map((landmark, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-4 rounded-xl bg-muted/50 hover:bg-muted/70 transition-colors duration-200"
                    >
                      <div className="flex items-center space-x-3">
                        <div className="flex items-center justify-center w-10 h-10 bg-secondary/20 rounded-lg">
                          <Icon
                            name={landmark?.icon}
                            size={18}
                            className="text-secondary"
                          />
                        </div>
                        <span className="text-base font-semibold text-foreground">
                          {landmark?.name}
                        </span>
                      </div>
                      <div className="text-right">
                        <p className="text-sm font-bold text-foreground">
                          {landmark?.distance}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {landmark?.type}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Transport View */}
      {activeView === "transport" && (
        <div className="bg-card rounded-xl shadow-warm p-8 border border-border/50">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {transportOptions?.map((transport, index) => (
              <div
                key={index}
                className="border border-border rounded-xl p-6 hover:shadow-md transition-all duration-200"
              >
                <div className="flex items-center space-x-4 mb-6">
                  <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-xl">
                    <Icon
                      name={transport?.icon}
                      size={24}
                      className="text-accent-foreground"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-foreground text-lg">
                      {transport?.type}
                    </h4>
                    <p className="text-base text-muted-foreground">
                      Caminhada: {transport?.walkTime}
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div>
                    <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">
                      {transport?.type === "Ciclovia"
                        ? "Acesso"
                        : "Linhas/Estação"}
                    </p>
                    <p className="text-base text-foreground font-semibold">
                      {transport?.station}
                    </p>
                  </div>

                  {transport?.lines && (
                    <div>
                      <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">
                        {transport?.type === "Ciclovia" ? "Rede" : "Opções"}
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {transport?.lines?.map((line, lineIndex) => (
                          <span
                            key={lineIndex}
                            className="px-3 py-2 bg-primary/10 text-primary text-sm rounded-lg font-semibold"
                          >
                            {line}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Additional Transport Info */}
          <div className="mt-8 p-6 bg-accent/10 rounded-xl border border-accent/20">
            <div className="flex items-start space-x-4">
              <Icon
                name="Info"
                size={20}
                className="text-accent-foreground mt-1"
              />
              <div>
                <h5 className="font-bold text-accent-foreground text-lg mb-3">
                  Dicas de Transporte
                </h5>
                <ul className="text-base text-accent-foreground space-y-2">
                  <li className="flex items-start space-x-2">
                    <span className="text-accent-foreground mt-1">•</span>
                    <span>Estacionamento gratuito disponível no local</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-accent-foreground mt-1">•</span>
                    <span>
                      Acesso facilitado para pessoas com mobilidade reduzida
                    </span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-accent-foreground mt-1">•</span>
                    <span>Bicicletário seguro e coberto</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-accent-foreground mt-1">•</span>
                    <span>Ponto de ônibus próximo ao estabelecimento</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationMap;
